import { render, staticRenderFns } from "./pileDonationServiceList.vue?vue&type=template&id=0b5f76c4&scoped=true"
import script from "./pileDonationServiceList.vue?vue&type=script&lang=js"
export * from "./pileDonationServiceList.vue?vue&type=script&lang=js"
import style0 from "./pileDonationServiceList.vue?vue&type=style&index=0&id=0b5f76c4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b5f76c4",
  null
  
)

export default component.exports